import { type IRole } from './authType'

export interface IBreadCrumb {
    title: string
    code: string
    formId: string
}

export enum EToastings {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
    WARN = 'warning'
}

export interface IRoutes {
    route: string
    component?: JSX.Element
    title: string | null
    allowedRoles: IRole[]
    children?: IRoutes[]
    // index?: boolean
}

export interface ISwapSequencs {
    srcId: string
    destId: string
}

export interface IApiErrorHandler {
    title?: string
    status?: 404
    detail?: { error: string } | string
    instance?: string
}

export interface ICommonField {
    name: string
    value: string | null
    placeholder: string
    error: string | null
    isTouched: boolean
}

export type TRole = 'ADMINISTRATOR' | 'SUPER_ADMINISTRATOR' | 'DMS_ADMINISTRATOR' | 'UNKNOWN'
export type TExistanceFilter = 'yes' | 'no' | null
